import { render } from "./LegendaStatiCliente.vue?vue&type=template&id=41bf4314&ts=true"
import script from "./LegendaStatiCliente.vue?vue&type=script&lang=ts"
export * from "./LegendaStatiCliente.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__